module.exports = __webpack_public_path__ + "media/images/element/error404-01-6d282dc1aeb5698b26cc14db0fdea7d6.svg";